export const ROUTES = {
  SIGNIN: '/signin',
  PROFILE: '/profile',
  HOME: '/',
  AUTH_CALLBACK: '/auth/callback',
};

export const ERROR_CODES = {
  PERSONNEL_NOT_FOUND: 'PERSONNEL_NOT_FOUND',
  EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
};

export const RESEND_COOLDOWN_SECONDS = 60;
export const NEW_USER_THRESHOLD_HOURS = 24;
